<template>
 <div>
      <v-app id="materialpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
          <router-view />
      </v-app>

 
      <v-dialog 
                transition="dialog-top-transition"
                max-width="800"
                v-model="dialog"
                persistent 
            >
                <v-card> 
                          <v-toolbar  color="#cc1d05"   dark >
                             <v-toolbar-title>Activate account</v-toolbar-title>
                          <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-card-text>            
                              <center>
                                 <v-img
                                      alt="Vuetify Name"
                                      class="shrink mt-4"
                                      contain
                                      min-width="100"
                                      src="http://www.playbuilderwithcoachd.com/iconos/usuario.png"
                                      width="200"
                                      />
                              </center>    
                              <hr>
                              <div class="row  justify-content-center">
                                <div class="col-md-5 text-center">
                                  <b-form-group>
                                    <h6 style="color:#cc1d05;">Access codes</h6>
                                    <b-form-input v-model="codigo" placeholder="Access codes"></b-form-input>
                                    <small class="text-danger" v-if="errors">required field</small>
                                  </b-form-group> 
                                   <div class="row  justify-content-center">
                                     <div class="col-md-6">
                                       <hr>
                                      <v-btn
                                          color="#cc1d05"
                                          dark
                                          @click="validarCod()"
                                      >validate <b-spinner v-if="loader" small></b-spinner></v-btn>
                                     </div>
                                     <div class="col-md-6">
                                       <hr>
                                      <v-btn
                                          dark
                                          @click="cerrarSesion()"
                                      ><v-icon>mdi-close</v-icon> Sign off</v-btn>
                                     </div>
                                     <div class="col-md-12">
                                       <p>Need an Access Code? Grab your Membership <a href="https://www.flagfootballwithcoachd.com/products/coach-ds-play-builder-create-and-import-plays-new-and-exclusive"  target="_blank"><b style="color:#cc1d05; cursor: pointer;">here</b></a></p>
                                     </div>
                                   </div>
                                </div>
                              </div>
                      </v-card-text> 
                </v-card>
        </v-dialog>
 </div>
</template>

<script>
import Cookies from "js-cookie";
import Swal from 'sweetalert2'
export default {
  name: 'App',
  data: () => ({
        idrol:1,
        value: 0,
        drawer: false,
        group: null, 
        dialog:false,
        video:0,
        codigo:"",
        errors:0,
        email:"",
        loader:false
      
  }),
  computed:{
      user() {
        return this.$store.getters.getInfoUser;
      },
    },
  created(){
     this.$bus.$on("menu-rol", () => {
        this.validaCuenta();
      });
   },
  methods:{
    cerrarSesion(){
      if (this.user.gmail == 1 && window.google && window.google.accounts) {
        window.google.accounts.id.disableAutoSelect();
      }

        this.$store.commit(
            "setLoginStatus",
            false
        );
        this.$store.commit(
            "setInfoUser",
            null
        );    
        Cookies.remove("session_id");
        location.reload();
    }, 
    validaCuenta(){ 
     var url= 'codigo/valid?email='+ this.user.email;
      this.$api.get(url).then(
            ({data}) => {
                if (data.valida == 1)
                {
                    this.dialog = true;
                    this.video = 1;
                }
                                
            }
        );
    },
    validarCod(){
      if (!this.codigo)
      {
        this.errors = 1;
      }else{
        this.loader = true;
        var url= 'codigo/aprove?codigo='+ this.codigo + '&email='+ this.user.email;
          this.$api.get(url).then(
                ({data}) => {
                  console.log(data);
                  this.loader = false;
                  if (data.valida == 1) {                    
                      Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Wrong access code'
                        })
                  }else{
                    // this.getUser();   
                    this.clear(); 
                  }                             
                }
            );
      }
    },
    abrirModal(){
      this.dialog = true; 
    },
    clear(){
      this.dialog = false; 
      this.loader = false;
    }
 }

};
</script>
